import { BASE_URL } from "../../data/BaseUrl";

export const fetchDashboardMenus = async (filters, token) => {
  let url = "admin/menu";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};

export const fetchDashboardFeatures = async (filters, token) => {
  let url = "admin";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};

export const fetchDashboardFeatureMapping = async (filters, token) => {
  let url = "admin/users";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};

export const fetchUserMappedFeature = async (filters, token) => {
  let url = "admin/feature/by-user";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};

export const fetchTransferedPT = async (filters, token) => {
  let url = "pt/transfer_pt";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};

export const fetchFeaturesDocumentation = async (filters, token) => {
  let url = "gym/feature_guide";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};

export const fetchDashboardFeedbacks = async (filters, token) => {
  let url = "gym/feature_feedback";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};

export const fetchDashboardFeatureGrouping = async (filters, token) => {
  let url = "admin/feature_group?is_user_specific=0";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};

export const fetchCheckinsStat = async (filters, token) => {
  let url = "attandance/checkin_stats";

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseJson = response.json();
    return responseJson;
  } catch (error) {
    return error;
  }
};
